import { render, staticRenderFns } from "./CreditorAgingReportSideMenu.vue?vue&type=template&id=6a1ff075&scoped=true"
import script from "./CreditorAgingReportSideMenu.vue?vue&type=script&lang=js"
export * from "./CreditorAgingReportSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ff075",
  null
  
)

export default component.exports